export const regionalOverview = {
  defaultYear: "Default year",
  selectYear: "Select year to compare",
  selectedYear: "Selected year",
  note: "*Note: The data presented in these graphs represents information that has been approved by the government.",
};
